import { inject } from '@angular/core';
import { Router, CanActivateFn, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DemoModeService } from '../services/demo-mode.service';

/**
 * Authentication-only guard — no membership check.
 * Use for routes accessible to any authenticated user regardless of brand membership
 * (e.g., /request-access, where non-members need access).
 *
 * - Unauthenticated → redirect to portal (store URL for post-auth redirect)
 * - Authenticated (member or non-member) → allow through
 */
export const authenticatedGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const demoModeService = inject(DemoModeService);

  if (demoModeService.isDemo()) {
    return of(true);
  }

  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      if (isAuthenticated) {
        return true;
      }
      sessionStorage.setItem('authRedirectUrl', state.url);
      return router.createUrlTree(['/']);
    })
  );
};
